import Forbidden from "../controllers/Forbidden/Forbidden";

const forbidden = (path, navigation) => ({
    path,
    navigation,
    component: Forbidden,
    exact: true,
});

export default forbidden;
